import React from "react";

const expertLine = () => {
    return (
        <svg viewBox="0 0 35 27" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M0 6C0 2.68629 2.68629 0 6 0H29C32.3137 0 35 2.68629 35 6V21C35 24.3137 32.3137 27 29 27H6C2.68629 27 0 24.3137 0 21V6Z"
                fill="#405D7B"
            />
            <path
                d="M16.6653 14.492H20.9493C20.9493 14.492 21.0573 14.096 21.0573 13.52C21.0573 12.944 20.9493 12.566 20.9493 12.566H16.6653V9.326H21.4893C21.4893 9.326 21.6153 8.948 21.6153 8.372C21.6153 7.778 21.4893 7.4 21.4893 7.4H17.6013C15.2253 7.4 13.6413 7.58 13.6413 7.58V19.82C13.6413 19.82 15.2253 20 17.6013 20H21.5793C21.5793 20 21.7053 19.622 21.7053 19.046C21.7053 18.452 21.5793 18.074 21.5793 18.074H16.6653V14.492Z"
                fill="white"
            />
        </svg>
    );
};

export default React.memo(expertLine);
